import { H, C, T } from '@homeschooling/sdk'

import m from 'moment'
import * as React from 'react'
import * as _ from 'lodash'

import Persistance from "../Persistence";
import { InputField } from './InputField'
import { DatePicker } from '../Common'
import { Exit } from '../../Components/Icons'
import { InputSwitch } from 'primereact/inputswitch'

import SDKFactory from '../../Components/SDKFactory'

//import { HorizontalLine } from '../Common/HorizonalLine'

interface Form {
    [key: string]: string
}

export interface Props {
    children?: React.ReactNode
    inPlaceUpdate: (x: T.Progress) => void
    closeForm: () => void
    form: Form
    errors: {[key: string]: string}
    date?: string
    note: T.Progress
}
  
export interface State {
    form: Form
    students: T.Student[]
    errors: {[key: string]: string}
}

Persistance.setValues()

export class EditNoteForm extends React.Component<Props, any> {

    private noteSdk = SDKFactory.getNotesSDK()

    public constructor (props: Props) {
        super(props)
        
        let form = {}

        if(this.props.note) {
            let note: T.Progress = this.props.note
        
            form = {
                student: note.students[0]?.id,
                event_id: note.schedule_id,
                date: note.date,
                subject: note.subject,
                course: note.course,
                notes: note.notes,
                description: note.description,
                time_spent: `${H.turnMinutesToHours(Math.round(Number(note.time_spent)))} `,
                Milestone: note.milestone
            }
        }

        this.state = {
            expandExpenses: false,
            expandNotes: false,
            form: form,
            students: Persistance.getStudents()
        }
    }

    public editNote = () => {

        let errors = this.verifyForm()

        if(Object.keys(errors).length !== 0){
            this.setState({errors: errors})
            return
        }

        let form = this.state.form
       
        let data: T.Progress = {
            students: [{
                id: form['student'],
                name: '',
                sex: '',
                dob: '',
                grade: '',
                special_needs: false,
                city: '',
                state: ''
            }],
                    schedule_id: form['event_id'],
                    subject: form['subject'],
                    course: form['course'],
                    notes: form['notes'],
                    description: form['notes'],
                    date: m(form['date']).format('YYYY-MM-DD'),
                    time_spent: H.turnHoursToMinutes(form['time_spent']).toString(),
                    add_to_transcript: form['transcript'] === 'true',
                    milestone: form['milestone'] === 'true'
                }    

        this.editNoteToSdk(data)

    }

    public editNoteToSdk = async (data: T.Progress) => {
            try{
    
                let id = this.props.note.id ? this.props.note.id?.toString() : '0'
                const res = await this.noteSdk.patchNote(id.toString(), data)
                let note = res.data
    
                const hasError: boolean = _.get(note, 'errors', false) as boolean
    
                if(!hasError && res.status === 'success'){
                    note = note as T.Progress
                    
                    //console.log('note', note)
                    this.props.inPlaceUpdate(note)
                    this.setState({form: {}})
                    this.props.closeForm()
                }
                return {}
            } catch (reason) {
                console.log('Error saving schedule event', reason)
                return {}
            }
        }

        public verifyForm = () => {
            const { form } = this.state
            let errors: any = {}

            if(!form.student) errors['student'] = 'Select a student'
            if(!form.subject) errors['subject'] = 'Select a subject'
            if(!form.course) errors['course'] = 'Select a course'
            if(!form.notes) errors['notes'] = 'Description is required'
            if(!form.time_spent) errors['notes'] = 'Time spent is required'
            //if(!form.transcripts !== undefined) errors['transcripts'] = 'Add to transscripts is required'
            if(!m(form.date).isValid()) errors['startDate'] = 'Date is required'

            return errors
        }
     
      public getStudentOptions = () => {
          let options: any = []
  
          for (let s of this.state.students){
              options[s.id] = s.name
          }
  
          return options
      }
  
      public getSubjectOption = () => {
          let subjects = C.subject
  
          let options: any = []
  
          _.forOwn(subjects, (value, key) => {
              options[key] = value.label
          })
  
          return options
      }
  
      public getCourseOption = () => {
  
          let options: any = []
  
          if(this.state.form.subject){
          let courses = C.getSubjectConstants(this.state.form.subject)
          
          _.forOwn(courses, (value, key) => {
              options[key] = value.label
          })
          }
  
          return options
      }
  
      public inputChanged = (key: string) =>
                (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
                  const { form } = this.state
                  form[key] = e.target.value
        
                  this.setState({
                    form,
                  })
    }
    
    public setDatePickerFormInfo = (key: string, e: any) =>  {
              const { form } = this.state
                form[key] = m(e).format()
      
                this.setState({
                  form,
                })
          }  

          public toggleAddToTranscripts = () => {
            let transcripts = false
    
            if(!this.state.form.transcripts || this.state.form.transcripts === false) {
                transcripts = true
            }
    
            const { form } = this.state
            form['transcripts'] = transcripts
            this.setState({form})
        }       
        
    public toggleMilestone = () => {

        let milestone = 'false'

        if (!this.state.form.milestone || this.state.form.milestone === 'false') {
            milestone = 'true'
        }

        const { form } = this.state
        form['milestone'] = milestone
        this.setState({ form })
    }

  public render(): React.ReactNode {

    const { form } = this.state

    return (
        <div className='w-120 flex flex-col'>
                        <div className='w-full flex flew-row items-center'>
                            <h2 className='w-auto grow text-left text-l font-semibold text-gray-900'>Edit Note</h2>
                            <div onClick={() => this.props.closeForm()} className='w-auto flex-none text-right justify-items-end hover:cursor-pointer'>
                                <Exit size='small'/> 
                            </div>
                        </div>
                  
                <form noValidate className="space-y-4 md:space-y-6">
                  <div className='w-full flex flex-col'>
                    <div className='w-full flex flex-row'>
                        <div className='w-1/2 p-2'>
                            <InputField
                                borderColor='default'
                                cb={this.inputChanged('student')}
                                disabled={form.event_id !== undefined}
                                errors={this.state.errors?.student}
                                helperErrors={true}
                                label={'Select A Student'}
                                labelColor='default'
                                id='student'
                                required={true}
                                options={this.getStudentOptions()}
                                type='select'
                                value={form.student}
                                placeHolder='Choose A Student'
                                />
                        </div>
                    </div>
                    <div className='w-full flex flex-row'>
                        <div className='w-1/2 p-2'>
                            <InputField
                                borderColor='default'
                                cb={this.inputChanged('subject')}
                                disabled={form.event_id !== undefined}
                                errors={this.state.errors?.subject ? true : false}
                                helperErrors={true}
                                label={'Subject'}
                                labelColor='default'
                                id='subject'
                                required={true}
                                options={this.getSubjectOption()}
                                type='select'
                                value={form.subject}
                                placeHolder='Select A Subject'
                                />
                        </div>
                        <div className='w-1/2 p-2'>
                        <InputField
                            borderColor='default'
                            cb={this.inputChanged('course')}
                            disabled={form.event_id !== undefined}
                            errors={this.state.errors?.course ? true : false}
                            helperErrors={true}
                            label={'Course'}
                            labelColor='default'
                            id='subject'
                            required={true}
                            options={this.getCourseOption()}
                            type='select'
                            value={form.course}
                            placeHolder='Select A Course'
                            />
                        </div>
                    </div>
                    <div className='w-full flex flex-row'>
                        <div className='w-1/2 p-2 relative'>
                        <div className='w-full'>
                                  Date*
                              </div>
                            <div className='w-full'>
                                                        <DatePicker                  
                                                            date={m(this.state.form.date).format()} cb={(e) => this.setDatePickerFormInfo('date', e)} />
                                                        </div>    
                        </div>
                        <div className='w-1/2 p-2'>
                         <InputField
                            borderColor='default'
                            cb={this.inputChanged('time_spent')}
                            disabled={form.event_id !== undefined && form.event_id !== null}
                            errors={this.state.errors?.time_spent ? true : false}
                            helperErrors={true}
                            label={'Time Spent'}
                            labelColor='default'
                            id='location'
                            required={false}
                            type='text'
                            value={form.time_spent}
                            placeHolder='45m, 1h, etc'
                            />
                        </div>
                   </div>
                   <div className='w-full p-2'>
                   <InputField
                            borderColor='default'
                            cb={this.inputChanged('notes')}
                            disabled={false}
                            errors={this.state.errors?.note ? true : false}
                            helperErrors={true}
                            label={'Note'}
                            labelColor='default'
                            id='note'
                            required={false}
                            type='textArea'
                            value={form.notes}
                            placeHolder='Progress note'
                            />
                   </div>
                   <div className='w-full my-2 flex flex-row'>
                                           <div className='w-1/2 flex flex-row justify-end'>
                                                                   
                                           </div>
                                           <div className='w-1/2 flex flex-row justify-end'>
                                               <div className='w-auto text-md text-right pr-4'>
                                                       Milestone
                                               </div>
                                               <div className='w-auto text-right'>
                                                   <InputSwitch checked={this.state.form.milestone === 'true'} onChange={(e) => this.toggleMilestone()} />
                                               </div>
                                           </div>
                                       </div>
                   <div className='w-full flex flex-row items-center'>
                                    <div className='w-auto grow text-right pr-4'>
                                    
                                    </div>
                                    <div className='w-auto flex-none justify-items-right'>
                                    <button
                                        onClick={() => this.editNote()} 
                                        type="button" 
                                        className="px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                                             Edit Note
                                        </button>
                                    </div>
                                </div>
                </div>
                    </form>
                </div>
    )
  }  
  
}

export default  EditNoteForm